import React, { Component } from 'react';
import { Toolbar, Divider } from '@redux-devtools/ui';
import ExportButton from './buttons/ExportButton.js';
import ImportButton from './buttons/ImportButton.js';
import PrintButton from './buttons/PrintButton.js';
import DispatcherButton from './buttons/DispatcherButton.js';
import SliderButton from './buttons/SliderButton.js';
import MonitorSelector from './MonitorSelector.js';
export default class BottomButtons extends Component {
    shouldComponentUpdate(nextProps) {
        return (nextProps.dispatcherIsOpen !== this.props.dispatcherIsOpen ||
            nextProps.sliderIsOpen !== this.props.sliderIsOpen ||
            nextProps.options !== this.props.options);
    }
    render() {
        const features = this.props.options.features;
        return (React.createElement(Toolbar, { borderPosition: "top" },
            features.export && React.createElement(ExportButton, null),
            features.import && React.createElement(ImportButton, null),
            React.createElement(PrintButton, null),
            React.createElement(Divider, null),
            React.createElement(MonitorSelector, null),
            React.createElement(Divider, null),
            features.jump && React.createElement(SliderButton, { isOpen: this.props.sliderIsOpen }),
            features.dispatch && (React.createElement(DispatcherButton, { dispatcherIsOpen: this.props.dispatcherIsOpen }))));
    }
}
